import React,{useState} from 'react';
import { Phone, Mail, MapPin, Send} from 'lucide-react';
const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <section id="contact" className="py-20">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-24 text-center space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900">Connect With Us</h2>
            <p className="text-xl md:text-2xl text-blue-800 max-w-4xl mx-auto leading-relaxed">
              Ready to make a difference in someone's life? Whether you need assistance, want to volunteer, or wish to support our cause, we're here to help. Reach out to us and become part of our compassionate community.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-5 items-stretch">
            {/* Contact Form */}
            <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-5 border border-white/30 shadow-xl h-fit-content flex flex-col">
              <h3 className="text-2xl font-bold text-blue-900 mb-6">Send us a Message</h3>
              <p className="text-blue-800 mb-6">
                Fill out the form below and we'll get back to you within 24 hours. All inquiries are treated with complete confidentiality.
              </p>
              <form onSubmit={handleSubmit} className="space-y-6" method="POST" name="contact-form" data-netlify="true">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-blue-900 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/50 backdrop-blur-sm border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-blue-900 placeholder-blue-600"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-blue-900 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/50 backdrop-blur-sm border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-blue-900 placeholder-blue-600"
                    placeholder="Enter your email address"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-blue-900 mb-2">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/50 backdrop-blur-sm border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-blue-900 placeholder-blue-600"
                    placeholder="Enter your phone number"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-blue-900 mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={5}
                    value={formData.message}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white/50 backdrop-blur-sm border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-blue-900 resize-none placeholder-blue-600"
                    placeholder="Tell us how we can help you or how you'd like to get involved..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2 shadow-lg"
                >
                  <Send className="h-5 w-5" />
                  <span>Send Message</span>
                </button>
              </form>
            </div>

            {/* Contact Information & Map */}
            <div className="space-y-8 h-full flex flex-col">
              <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-8 border border-white/30 shadow-xl">
                <h3 className="text-2xl font-bold text-blue-900 mb-6">Contact Information</h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <MapPin className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-blue-900 mb-1">Our Address</h4>
                      <p className="text-blue-800">OOTTUPARA JUNCTION PALLIKUNNU PO<br />Wayanad, Kerala, India 682001</p>

                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Phone className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-blue-900 mb-1">Phone Numbers</h4>
                      <p className="text-blue-800">Main Office: +91 9495921988 </p>
                      <p className="text-blue-800">President: +91 9744181761</p>
                      <p className="text-blue-800">Secretary: +91 9605289750</p>
                      <p className="text-blue-800">Treasurer: +91 9446889453</p>
                      <p className="text-blue-800">Vice President: +91 9605640733 </p>
                      <p className="text-blue-800">Joint Secretary: +91 8848329706</p>

                      <p className="text-sm text-blue-600 mt-1">Available 24/7 for emergencies</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Mail className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-blue-900 mb-1">Email Addresses</h4>
                      <p className="text-blue-800">General: st.alphonsacharitabletrust@gmail.com</p>
                      <p className="text-sm text-blue-600 mt-1">Response within 24 hours</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Office Hours */}
              <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-8 border border-white/30 shadow-xl">
                <h3 className="text-2xl font-bold text-blue-900 mb-6">Office Hours</h3>
                <div className="space-y-2 text-blue-800">
                  24/7 Available
                  <div className="flex justify-between border-t border-blue-200 pt-2 mt-4">
                    <span>Emergency Services:</span>
                    <span className="font-semibold text-blue-600">24/7 Available</span>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
             
            </div>
          </div>
           <div className="mt-16 bg-white/40 backdrop-blur-lg rounded-2xl p-8 border border-white/30 shadow-xl">
  <h3 className="text-2xl font-bold text-blue-900 mb-6">
    Find Us
  </h3>

  {/* Map Container */}
  <div className="relative w-full h-[400px] rounded-xl overflow-hidden border border-blue-200 shadow-md">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3907.2289364185476!2d76.059781!3d11.678180999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDQwJzQxLjUiTiA3NsKwMDMnMzUuMiJF!5e0!3m2!1sen!2sin!4v1767505664518!5m2!1sen!2sin"
      className="absolute inset-0 w-full h-full border-0"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
      title="location"
    />
  </div>
</div>

        </div>
      </section>
  );
};

export default Contact;
